import { render, staticRenderFns } from "./main-pagination.vue?vue&type=template&id=402475b6&scoped=true"
import script from "./main-pagination.vue?vue&type=script&lang=js"
export * from "./main-pagination.vue?vue&type=script&lang=js"
import style0 from "./main-pagination.vue?vue&type=style&index=0&id=402475b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402475b6",
  null
  
)

export default component.exports